module.exports = __webpack_public_path__ + "img/scene2.078d02a8.png";